import React from 'react'
import { STATICS } from 'statics'
import { DEFAULT_CONTACT_NUMBER } from 'app-constants'

export const BUTTON_THEME = {
  GO_TO_INVOICES: 'GO_TO_INVOICES',
  WHATS_APP_SUPPORT: 'WHATS_APP_SUPPORT',
  RESCHEDULE: 'RESCHEDULE',
  CANCEL: 'CANCEL',
  FINISH: 'FINISH',
}

export const BUTTON_CONTENT = {
  [BUTTON_THEME.GO_TO_INVOICES]: {
    TEXT: 'Ir para minhas faturas',
  },
  [BUTTON_THEME.WHATS_APP_SUPPORT]: {
    ICON: <STATICS.WHATSAPP_BADGE />,
    TEXT: 'Falar com atendente',
  },
  [BUTTON_THEME.RESCHEDULE]: {
    TEXT: 'Reagendar visita',
  },
  [BUTTON_THEME.CANCEL]: {
    TEXT: 'Cancelar visita',
  },
  [BUTTON_THEME.FINISH]: {
    TEXT: 'Ok, entendi!',
  },
}

export const ALERT_THEME = {
  SUCCESS: 'SUCCESS',
  OPEN_INVOICES: 'OPEN_INVOICES',
  UNAVAILABLE_FEATURE: 'UNAVAILABLE_FEATURE',
  ADDRESS_INVIABILITY: 'ADDRESS_INVIABILITY',
  ERROR: 'ERROR',
  CONDOMINIUM_NOT_REGISTERED: 'CONDOMINIUM_NOT_REGISTERED',
}

export const ALERT_THEME_CONTENT = {
  [ALERT_THEME.SUCCESS]: {
    ICON: <STATICS.SUCCESS className='green' />,
    TITLE: 'Sua solicitação foi cadastrada com sucesso!',
    DESCRIPTION: 'Aguarde a visita do técnico na data agendada.',
  },
  [ALERT_THEME.OPEN_INVOICES]: {
    ICON: <STATICS.INFO_ERROR />,
    TITLE: 'Você possui faturas em aberto',
    DESCRIPTION:
      'Efetue o pagamento pendente para solicitar a mudança de endereço. Se o pagamento já foi efetuado, aguarde a compensação bancária.',
    BUTTON: BUTTON_THEME.GO_TO_INVOICES,
  },
  [ALERT_THEME.ADDRESS_INVIABILITY]: {
    ICON: <STATICS.INFO_CIRCLE className='primary' />,
    DESCRIPTION: (
      <div className='address-inviability'>
        <p>
          Ops! Não conseguimos seguir com esse endereço por aqui, mas em alguns casos nosso time
          consegue resolver.
        </p>

        <p>
          <span className='bold'>É só ligar no {DEFAULT_CONTACT_NUMBER}</span> que a gente te ajuda!
          A ligação é rapidinha.
        </p>
      </div>
    ),
    BUTTON: BUTTON_THEME.FINISH,
  },
  [ALERT_THEME.ERROR]: {
    ICON: <STATICS.INFO_ERROR />,
    TITLE: 'Não foi possível concluir a sua solicitação',
    DESCRIPTION: 'Entre em contato conosco através do WhatsApp.',
    BUTTON: BUTTON_THEME.WHATS_APP_SUPPORT,
  },
  [ALERT_THEME.UNAVAILABLE_FEATURE]: {
    ICON: <STATICS.INFO_CHAT />,
    TITLE: 'Essa  funcionalidade está  temporariamente indisponível',
    DESCRIPTION:
      'Entre em contato conosco através do WhatsApp que iremos te ajudar com a sua solicitação.',
    BUTTON: BUTTON_THEME.WHATS_APP_SUPPORT,
  },
  [ALERT_THEME.CONDOMINIUM_NOT_REGISTERED]: {
    ICON: <STATICS.INFO_CHAT />,
    TITLE: 'Obrigado pela confirmação de dados',
    DESCRIPTION:
      'Já conseguimos avaliar em nossos sistemas, mas para continuar seu agendamento, será necessário falar com um atendente por aqui mesmo.\n\nClique no botão abaixo e você já será atendido para terminar o processo.',
    BUTTON: BUTTON_THEME.WHATS_APP_SUPPORT,
  },
}
